export default function SectionHeading({ eyebrow, title, intro, as: Tag = "h2", light = false, id, className = "" }) {
  return (
    <div className={`max-w-2xl ${className}`}>
      {eyebrow && <p className={`eyebrow ${light ? "text-amber" : ""}`}>{eyebrow}</p>}
      <Tag id={id} className={`mt-3 font-serif text-3xl leading-[1.1] sm:text-4xl lg:text-[2.9rem] ${light ? "text-cream" : "text-ink"}`}>
        {title}
      </Tag>
      {intro && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${light ? "text-cream/80" : "text-muted"}`}>{intro}</p>}
    </div>
  );
}
